import React from 'react';
import { Helmet } from 'react-helmet';
import { SectionHero } from './products/loan-origination/_hero';
import { SectionOverview } from './products/loan-origination/_overview';
import { SectionCloser } from './index/_closer';
import { Layout } from '~/components/Layout';
import { AllProducts } from '~/components/AllProducts';
import { Testimonials } from '~/components/Testimonials';
import { Footer } from '~/components/Footer';

const LoanOriginationPage: React.FC = () => {
  return (
    <Layout noFooter bg="#F6F7FA">
      <Helmet>
        <title>Loan Origination — Column</title>
        <meta property="og:title" content="Column - Loan Origination" />
        <meta
          name="description"
          content="Configure and build a flexible national lending program with a nationally chartered bank partner that operates like a fintech."
        />
      </Helmet>
      <SectionHero />
      <SectionOverview />
      <Testimonials />
      <AllProducts background="#F6F7FA" accentColor="#E7E9EE" />
      <div className="relative overflow-hidden">
        <SectionCloser />
        <Footer />
      </div>
    </Layout>
  );
};

export default LoanOriginationPage;
